export class OfferModel {
    offerId: number;
    buyerId: number;
    sellerId: number;
    offerItemId: number;
    itemName: string;
    itemImage: string;
    itemPrice: number;
    quantity: number;
    discount: number;
    amount: number;
    customerFirstname: string;
    customerLastname: string;
    customerCompanyName: string;
    customerAddressLine1: string;
    customerAddressLine2: string;
    customerCity: string;
    customerState: string;
    customerPostcode: string;
    customerCountry: string;
    customerEmail: string;
    customerContactNumber: string;
    notes: string;
    state: string;
    createdTime: Date;
    stateLogs: OfferStateLog[];
    termsAccepted: string;
    constructor(data?: any) {
        this.offerId = data?.offerId ?? 0;
        this.buyerId = data?.buyerId ?? 0;
        this.sellerId = data?.sellerId ?? 0;
        this.offerItemId = data?.offerItemId ?? 0;
        this.itemName = data?.itemName ?? "";
        this.itemImage = data?.itemImage ?? "";
        this.itemPrice = data?.itemPrice ?? 0;
        this.quantity = data?.quantity ?? 0;
        this.discount = data?.discount ?? 0;
        this.amount = data?.amount ?? 0;
        this.customerFirstname = data?.customerFirstname ?? "";
        this.customerLastname = data?.customerLastname ?? "";
        this.customerCompanyName = data?.customerCompanyName ?? "";
        this.customerAddressLine1 = data?.customerAddressLine1 ?? "";
        this.customerAddressLine2 = data?.customerAddressLine2 ?? "";
        this.customerCity = data?.customerCity ?? "";
        this.customerState = data?.customerState ?? "";
        this.customerPostcode = data?.customerPostcode ?? "";
        this.customerCountry = data?.customerCountry ?? "";
        this.customerEmail = data?.customerEmail ?? "";
        this.customerContactNumber = data?.customerContactNumber ?? "";
        this.notes = data?.notes ?? "";
        this.state = data?.state ?? "";
        this.stateLogs = Array.isArray(data?.stateLogs) ? data.stateLogs.map((x: any) => new OfferStateLog(x.offerStateLogId, x.offerId, x.offerState, x.logTime)) : [];
        this.createdTime = data?.createdTime ? new Date(data.createdTime) : new Date();
        this.termsAccepted = data?.termsAccepted ?? "";
    }

}

export class OfferStateLog {
    offerStateLogId: number;
    offerId: number;
    offerState: string;
    logTime: Date;

    constructor(
        offerStateLogId: number,
        offerId: number,
        offerState: string,
        logTime: string | Date
    ) {
        this.offerStateLogId = offerStateLogId;
        this.offerId = offerId;
        this.offerState = offerState;
        this.logTime = typeof logTime === 'string' ? new Date(logTime) : logTime;
    }
}